/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "redux/store";
import { IAddHealthOrderTypes, IInvoice } from "shared/interface/types";

const initialState: { HealthOrder: IAddHealthOrderTypes; Invoice: IInvoice } = {
  HealthOrder: {
    id: "",
    customerDetailId: "",
    name: "",
    healthPlanId: null,
    planName: "",
    productName: "",
    cartId: "",
    lineOfBussiness: {
      id: null,
      name: ""
    },
    takafulProvider: {
      id: "",
      companyName: ""
    },
    paymentFrequency: {
      id: null,
      name: ""
    },
    planType: {
      id: null,
      name: ""
    }
  },
  Invoice: {
    id: "",
    dueDate: "",
    amount: "",
    currencySymbol: "",
    paidAt: "",
    currencyId: 0,
    tax: "",
    createdById: "",
    updatedById: "",
    createdAt: "",
    updatedAt: "",
    activityFkId: "",
    payerUserId: "",
    paymentStatusId: 0,
    pickupAddress: "",
    activity: {
      id: 0,
      value: ""
    },
    type: {
      id: 0,
      value: ""
    },
    paymentStatus: {
      id: 0,
      key: "",
      value: ""
    },
    paymentMode: {
      id: 0,
      value: ""
    },
    paymentMethod: {
      id: 0,
      value: ""
    },
    currency: {
      id: 0,
      name: "",
      code: "",
      symbol: ""
    },
    totalContributionValue: "",
    amountValue: "",
    updatedBy: {
      id: 0,
      name: ""
    },
    payer: {
      id: "",
      contactNumber: "",
      name: "",
      isActive: true,
      email: "",
      profileImage: "",
      userType: {
        id: 0,
        key: ""
      }
    }
  }
};

const healthOrderSlice = createSlice({
  name: "healthOrder",
  initialState,
  reducers: {
    AddHealthOrder: (state, action) => {
      state.HealthOrder = action.payload;
    },
    AddOrderInvoice: (state, action) => {
      state.Invoice = action.payload;
    },
    DeleteHealthOrder: state => {
      state.HealthOrder = initialState.HealthOrder;
    }
  }
});

export const { AddHealthOrder, AddOrderInvoice, DeleteHealthOrder } = healthOrderSlice.actions;
export default healthOrderSlice.reducer;

export const getHealthOrder = (state: RootState) => state.healthOrder;
export const getInvoice = (state: RootState) => state.healthOrder;
